import React from 'react';
import { AdminCard, AdminTable } from '../AdminUI';

const AdminRecentTable = ({ columns, rows, emptyMessage = 'No records found.' }) => {
  return (
    <AdminCard className="p-0">
      <AdminTable columns={columns} rows={rows} emptyMessage={emptyMessage} />
    </AdminCard>
  );
};

export default AdminRecentTable;
